import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import {AiFillHeart, AiOutlineHeart, AiFillDelete} from 'react-icons/ai'
import Moment from "react-moment"
const ProductCard = ({
  productImage,
  productPrice,
  sellerName,
  productName,
  setWidth,
  setHeight,
  imgHeight,
  imgWidth,
  isLiked ,
  handleHeartIcon,
  linkTo,
  auctionBy,
  auctionTime,
  isAuctionCard,
  showDeleteBtn,
  handleDeleteBtn,
  product,
}) => {


  return (
    <CardWrapper style={{ width: setWidth, height: setHeight }}>
       {
         isAuctionCard ?
         null
         :
         <div onClick={handleHeartIcon} className="heartIcon">
         {
             !isLiked?
             <AiOutlineHeart size={20} color={"#000"} />
             :
             <AiFillHeart size={20} color={"red"} />
          
         }
         
       </div>
       }
      
      {
         showDeleteBtn && 
         <AiFillDelete onClick={handleDeleteBtn} style={{position: 'absolute', right: '0.2rem', top: '0.2rem'}} size={20} color={"red"} />
       }
      <Link className="link" to={linkTo}>
      <img
        style={{ width: imgWidth, height: imgWidth }}
        className="productImage"
        src={productImage}
        alt=""
      />
      <div className="product_details">
        <span className="product_name">{productName}</span>
        {
          isAuctionCard ?
          <span className="product_price">{`Auction Price -${product?.currency} ${productPrice}`}</span>
          :
          <div>
             {
              product?.discountedPrice &&
              <span className="product_price discounted_price">{`${product?.currency} ${product?.discountedPrice}`}</span>
            }
            {
              product?.discountedPrice?
              <del className="product_price">{`${product?.currency} ${productPrice}`}</del>
              :
              <span className="product_price">{`${product?.currency} ${productPrice}`}</span>
            }
            </div>
        }
        <span className="seller_name">{sellerName}</span>
        {
          isAuctionCard &&
          <>
          <span className="auction_by">{`Auction By ${auctionBy}`}</span>
        <span className="auction_by">Time- 
        <Moment  date={auctionTime} parse='DD-MM-YYYY HH:mm'  />
        </span>
          </>
        }
      </div>
      </Link>
    </CardWrapper>
  )
}

export default ProductCard

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  position: relative;

  @media screen and (max-width: 768px){
      margin: 10px;
      height: 280px !important;
    }

  .link {
    text-decoration: none;
  }
  .productImage {
    border-radius: 5px;
    cursor: pointer;


    @media screen and (max-width: 768px){
      width: 5rem;
      height: 6rem;
    }
  }

  .product_details {
    display: flex;
    flex-direction: column;
    width: 100%;
    cursor: pointer;
  }

  .product_name {
    font-size: 1rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    color: ${({ theme }) => theme.primaryText};
    margin-bottom: 0.3rem;    

  }
  .product_price {
    font-size: 1rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.secondryText};
    margin-bottom: 0.3rem;
    cursor: pointer;

  }

  .discounted_price {
    color: ${({ theme }) => theme.green};
    font-weight: 600;
    margin-right: 1rem;
  }
  .seller_name {
    font-size: 1rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 300;
    color: ${({ theme }) => theme.text};
    margin-bottom: 0.3rem;
    cursor: pointer;

  }

  .auction_by {
    font-size: 0.8rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 300;
    color: ${({ theme }) => theme.text};
    margin-bottom: 0.3rem;
    cursor: pointer;
  }

  .heartIcon {
    position: absolute;
    right: 5px;
    top: 5px;
    
  }
`
